module.exports = require("core-js-compat/entries");
